import { lazy } from 'react';
import PublishUtils from "../../../../../helpers/PublishUtils";

export const ShaclFormDescription = {
    name: 'ShaclForm',
    component:lazy(() => import('./ShaclForm' )),
    label: 'Shacl Form Experimental',
    variables: [
      {
        name: 'query',
        type: 'yasgui',
        label:
          'shacl construct query to get the shapes. ',
      },

      {
        name: 'shaclttl',
        type: 'text',
        label:
          'shacl shape in ttl format (without # statements)',
      },

    
      
      {
        name: 'graph',
        type: 'text',
        label:
          'graph parameter to retreive and store the data',
      },

      
      {
        name: 'uri',
        type: 'text',
        label:
          'mandatory parameter of the resource to edit. use "newuri:{{baseuri}}" to create a new resource',
      },
       {
        name: 'shacluri',
        type: 'text',
        label:
          'optional uri of the shacl shape . not implemented yet',
      },
        {
        name: 'rules',
        type: 'text',
        label:
          'shaclform rules . not implemented yet ',
      },
      {
        name: 'loadAllFromGraph',
        type: 'boolean',
        label:
          'Load all from graph to fill selection boxes (only for small graphs). it uses the property lang for filtering labels if available',
      },
       {
        name: 'loadAllFromSparql',
        type: 'yasgui',
        defaultQuery:'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX owl: <http://www.w3.org/2002/07/owl#>\n\nCONSTRUCT {?a rdfs:subClassOf ?parent.?a a ?cls.?a rdfs:label ?label} where {graph <{{graph}}> { values (?cls) {(rdfs:Class) (owl:Class)} .   ?a a ?cls. optional {?a rdfs:subClassOf ?parent. filter (!ISBLANK(?parent))} optional {?a rdfs:label ?label} } }   #nocache; ',
        label:'CONSTRUCT QUERY Load all from graph to fill selection boxes. So the results of this query will be added to the shacl shape.'
      },

       {
        name: 'dataview',
        type: 'boolean',
        label:
          'use view (not sure if it is working)',
      },

 {
        name: 'extraTriples',
        type: 'yasgui',
        defaultQuery:'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\nPREFIX owl: <http://www.w3.org/2002/07/owl#>\n\nCONSTRUCT {?a rdfs:subClassOf ?parent.?a a ?cls.?a rdfs:label ?label} where {graph <{{graph}}> { values (?cls) {(rdfs:Class) (owl:Class)} .   ?a a ?cls. optional {?a rdfs:subClassOf ?parent. filter (!ISBLANK(?parent))} optional {?a rdfs:label ?label} } }   #nocache; ',
        label:'CONSTRUCT QUERY. The results are inserted in the same graph as the form data after submission.'
      },

       {
        name: 'predsToAdd',
        type: 'text',
         label:'predicates that do not have to be deleted first (comma separated uris) (not implemented yet)'
      },




      PublishUtils.getTimestampParametersDef(),
        {
          name: 'successMessage',
          type: 'text',
          label: 'form submission success message',
        },
        {
          name: 'failureMessage',
          type: 'text',
          label: 'failure message',
        },
         {
          name: 'closePopup',
          type: 'boolean',
          label: 'close popup after succesful submit',
        }

      
     
    ]
  }